

























































import { Component, Vue, Prop } from 'vue-property-decorator';
// @ts-ignore
import AddIcon from '../../../public/add.svg';
// @ts-ignore
import ListIcon from '../../../public/list.svg';
// @ts-ignore
import EyeglassIcon from '../../../public/eyeglasses.svg';
// @ts-ignore
import CopyIcon from '../../../public/copy.svg';
// @ts-ignore
import ExtractorIcon from '../../../public/upload.svg';
// @ts-ignore
import ManyIcon from '../../../public/many.svg';
// @ts-ignore
import HelpIcon from '../../../public/question.svg';
// @ts-ignore
import CSVIcon from '../../../public/csv.svg';
// @ts-ignore
import GotoIcon from '../../../public/right.svg';
// @ts-ignore
import BookmarkIcon from '../../../public/bookmark.svg';
// @ts-ignore
import FilterIcon from '../../../public/filter.svg';
// @ts-ignore
import ColumnIcon from '../../../public/column.svg';
// @ts-ignore
import ImportIcon from '../../../public/import.svg';
// @ts-ignore
import WriteIcon from '../../../public/write.svg';
// @ts-ignore
import SnippetIcon from '../../../public/snippet.svg';
// @ts-ignore
import LoopIcon from '../../../public/loop.svg';
// @ts-ignore
import MacroIcon from '../../../public/macro.svg';
// @ts-ignore
import LearnIcon from '../../../public/learn.svg';
// @ts-ignore
import InviteIcon from '../../../public/invite.svg';

@Component({
	components: {
		AddIcon,
		ListIcon,
		EyeglassIcon,
		CopyIcon,
		ExtractorIcon,
		ManyIcon,
		HelpIcon,
		CSVIcon,
		GotoIcon,
		BookmarkIcon,
		FilterIcon,
		ColumnIcon,
		ImportIcon,
		WriteIcon,
		SnippetIcon,
		LoopIcon,
		MacroIcon,
		LearnIcon,
		InviteIcon,
	}
})
export default class Icon extends Vue {
	@Prop() private iconType!: string;
}
